import { render, staticRenderFns } from "./TeamTabs.vue?vue&type=template&id=2c4a0b10&scoped=true"
import script from "./TeamTabs.vue?vue&type=script&lang=js"
export * from "./TeamTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4a0b10",
  null
  
)

export default component.exports